export const durationOptions = [
  { value: 'this fiscal year', label: 'This Fiscal Year' },
  { value: 'last 12 month', label: 'Last 12 months' },
  { value: 'last 6 month', label: 'Last 6 months' },
];

export const test = 'test';
